import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router";

const StyledWrapper = styled.div`{
    margin: auto;
    padding: 10px;
    margin-top: 23px
    max-width: 1080px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    background: #FFFFFF;
    border: 1px solid #DADCE0;
    box-sizing: border-box;
    border-radius: 8px;
}`;
const img = process.env.PUBLIC_URL + "/images/errorBeanie.png";

export const ImageContainer = styled.div`
  text-align: center;
  display: block;
  height: 300px;
`;

class ErrorPage extends Component {
  render() {
    const { error, authentication } = this.props;
    console.log("ERROR: ", error);

    /*
     * if(authentication.isSystemAdmin)
     *   return (
     *     <StyledWrapper>
     *       <p>What did you click on!!!!</p>
     *       <p>F*uck you dude. It'll get get fixed when it is fixed.</p>
     *       <p>Ryan is going to remove your account if you don't stop screwing up.</p>
     *       <iframe src="https://giphy.com/embed/44Eq3Ab5LPYn6" width="480" height="437" frameBorder="0" class="giphy-embed" allowFullScreen></iframe>
     *     </StyledWrapper>);
     */

    return (
      <StyledWrapper>
        <p>Oh no, looks like something has gone wrong.</p>
        <p>Our technology team has been notified and is working to resolve this issue.</p>
        <p>Thank you for your patience.</p>
      </StyledWrapper>
    );
  }
}

const mapStateToProps = ({ authentication }) => ({
  authentication
});

export default compose(
  withRouter
  , connect(mapStateToProps, {})
)(ErrorPage);
